import jsonApi from '../../utils/jsonApi'
import http from '../../utils/http'

export const viewNotification = id => {
  return http.get(`notifications/views/${id}`).then(res => res)
}

export const getNotifications = payload => {
  try {
    return jsonApi
      .customRequest(
        'GET',
        'notifications/viewed',
        'notifications',
        undefined,
        {
          params: {
            ...payload.params,
            'page[number]': payload.page || 1
            // include: 'room'
          }
        }
      )
      .then(res => {
        return res
      })
  } catch (err) {
    console.error(err)
  }
}
